import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/reception";
const API_PATH_2 = ConstantList.API_EN_POINT + "/patient";
export const checkIn = (checkIn) => axios.post(API_PATH + "/check-in", checkIn);

export const CheckOut = (searchObject) =>
  axios.post(API_PATH + "/check-out-auto", searchObject);

export const pagingCheckIn = (searchObject) =>
  axios.post(API_PATH + "/paging-check-in", searchObject);

export const getCheckinById = (id) =>
  axios.get(API_PATH + `/get-checkin-detail/${id}`);

export const cancleCheckIn = (recEncounterId) =>
  axios.delete(API_PATH + `/cancel-check-in/${recEncounterId}`);

export const cancleCheckOut = (visitIds) =>
  axios.post(API_PATH + "/check-out-list-visits", { visitIds });

export const checkOut = (checkOut) =>
  axios.post(API_PATH + "/check-out", checkOut);

export const checkPatient = (patient) =>
  axios.post(API_PATH_2 + "/paging-patient", patient);

export const pagingReceptionEncounter = (searchObject) =>
  axios.post(API_PATH + "/paging-reception-encounter", searchObject);

export const checkCompanions = (obj) =>
  axios.post(API_PATH + "/check-companions", obj);

export const exportExcelCheckinList = (obj) => {
  let url = API_PATH + "/export-excel-checkin-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const checkPatientNative = (patient) =>
  axios.post(API_PATH_2 + "/search-by-phone-number-native", patient);
